import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const HomeIcon = (props: IconProps) => (
  <Icon
    fillOpacity="0"
    viewBox="0 0 16 16"
    fill="none"
    title={t`Home`}
    {...props}
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m.9 7 7-5 7 5"
      fill="none"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.9 6v8h3M12.9 6v8h-3"
      fill="none"
    />
  </Icon>
);
